/**
 * Auth flow design tokens — exact values from Figma delivery spec
 * node: 305:213416  "Sign up / Login"
 *
 * These values are intentionally separate from the app-wide theme because
 * the auth design uses a blue primary (#1656CF) while the brand primary
 * is purple (#6442B3). Import from here instead of hardcoding inline.
 */
import { rawColors } from "../design-system/tokens/colors";

export const authColors = {
  // ── Gradient (page background + right panel) ────────────────────────────
  gradientStart:     '#EDF3FC',   // rgb(237,243,252) — light blue
  gradientEnd:       '#F4EAF3',   // rgb(244,234,243) — light pink/lavender
  gradientAngle:     '230.49deg',
  gradientStartStop: '40.95%',
  gradientEndStop:   '91.01%',

  // ── Surfaces ─────────────────────────────────────────────────────────────
  white:             '#FFFFFF',

  // ── Text ─────────────────────────────────────────────────────────────────
  textHighEmphasis:  rawColors.text.highEmphasis,   // --text/high-emphasis
  textMedEmphasis:   rawColors.text.mediumEmphasis,   // --text/medium-emphasis

  // ── Interactive / button ─────────────────────────────────────────────────
  buttonPrimary:         '#1656CF',  // --text/interactive (auth blue)
  buttonPrimaryHover:    '#1248B0',
  buttonPrimaryDisabled: '#8DB0E9',
  buttonPrimaryText:     '#FFFFFF',

  // ── Inputs & borders ─────────────────────────────────────────────────────
  inputBorder:       rawColors.stroke[200],   // --stroke/200
  inputShadow:       '1px 1px 4px 0px rgba(89,98,112,0.1)',

  // ── Card shadows ─────────────────────────────────────────────────────────
  cardShadow:        '0px 4px 20px 2px rgba(89,98,112,0.1), 0px 2px 6px 0px rgba(89,98,112,0.15)',
  panelShadow:       '0px 2px 6px 0px rgba(89,98,112,0.15)',

  // ── Preview panel ────────────────────────────────────────────────────────
  previewBorder:         '#3E3045',   // dark purple frame on main image
  activeThumbnailBorder: '#3A73DF',   // --primary/400 equivalent

  // ── Error ────────────────────────────────────────────────────────────────
  error:             '#E53935',
} as const;

/** CSS gradient string — reuse wherever the auth gradient is needed */
export const authGradient =
  `linear-gradient(${authColors.gradientAngle}, ${authColors.gradientStart} ${authColors.gradientStartStop}, ${authColors.gradientEnd} ${authColors.gradientEndStop})`;
